export default "__VITE_ASSET__1b77f4bf__"